import { CreatorChallenge } from '../../../../types/challenges';
import {
  formatChallengeCompletedDate,
  getChallengeRewardTypeLabel,
  getChallengeTitle,
  getCompletedChallengeStatus,
} from '../../../../utils/challenge-utils';
import ChallengeRewardValue from './ChallengeRewardValue';
import ChallengeStatusTag from './ChallengeStatusTag';
import styles from './allChallenges.module.css';

type CompletedChallengesTableProps = {
  challenges: CreatorChallenge[];
  defaultCurrency: string;
  onClaimReward: (challenge: CreatorChallenge) => void;
};

export default function CompletedChallengesTable({
  challenges,
  defaultCurrency,
  onClaimReward,
}: CompletedChallengesTableProps) {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.challengeCol}>Challenge</th>
            <th className={styles.rewardCol}>Reward</th>
            <th className={styles.valueCol}>Value</th>
            <th className={styles.dateCol}>Completed on</th>
            <th className={`${styles.statusCol} ${styles.statusColHeader}`}>Status</th>
          </tr>
        </thead>
        <tbody>
          {challenges.map((challenge) => (
            <tr key={challenge.id}>
              <td
                className={`${styles.challengeCol} ${styles.ellipsis}`}
                title={getChallengeTitle(challenge, defaultCurrency)}
              >
                {getChallengeTitle(challenge, defaultCurrency)}
              </td>
              <td className={styles.rewardCol}>{getChallengeRewardTypeLabel(challenge)}</td>
              <td className={styles.valueCol}>
                <ChallengeRewardValue challenge={challenge} defaultCurrency={defaultCurrency} />
              </td>
              <td className={styles.dateCol}>{formatChallengeCompletedDate(challenge.completedAt)}</td>
              <td className={`${styles.statusCol} ${styles.statusCell}`}>
                <ChallengeStatusTag
                  status={getCompletedChallengeStatus(challenge)}
                  onClaim={() => onClaimReward(challenge)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
